/* PP v21: small, additive patches to the theme's <predictive-search> element
   (assets/predictive-search.js stays untouched).
   1. Ask the predictive search API for up to 6 results of each type
      (products grid shows 6; suggestions/collections are capped in Liquid).
   2. Keyboard navigation walks every visible result in document order,
      across the suggestions, collections, products and "view all" lists
      (the original only walked one tab panel's siblings).
   3. On desktop, nudge the wide header panel so it never runs past the
      right edge of the viewport. */
(function () {
  if (window.ppPredictiveSearchPatched) return;
  window.ppPredictiveSearchPatched = true;

  if (window.theme && theme.settings) {
    var limit = parseInt(theme.settings.pSearchLimit, 10) || 0;
    if (limit < 6) theme.settings.pSearchLimit = 6;
    theme.settings.pSearchLimitScope = 'each';
  }

  if (!window.customElements) return;

  customElements.whenDefined('predictive-search').then(function () {
    var Ctor = customElements.get('predictive-search');
    if (!Ctor) return;
    var proto = Ctor.prototype;

    var isVisible = function (el) {
      return !el.closest('[hidden]') && el.getClientRects().length > 0;
    };

    proto.handleResultsNav = function (key) {
      var allResults = Array.prototype.filter.call(
        this.querySelectorAll('.predictive-search__item'),
        isVisible
      );
      if (!allResults.length) return;

      var selectedResult = null;
      for (var i = 0; i < allResults.length; i += 1) {
        if (allResults[i].getAttribute('aria-selected') === 'true') {
          selectedResult = allResults[i];
          break;
        }
      }
      var index = selectedResult ? allResults.indexOf(selectedResult) : -1;
      var resultToSelect = allResults[0];

      if (key === 'ArrowUp') {
        if (!selectedResult) return;
        resultToSelect = allResults[index - 1] || allResults[allResults.length - 1];
      } else if (key === 'ArrowDown' && selectedResult) {
        resultToSelect = allResults[index + 1] || allResults[0];
      }

      this.statusEl.textContent = '';
      if (!resultToSelect || resultToSelect === selectedResult) return;

      resultToSelect.setAttribute('aria-selected', 'true');
      if (selectedResult) selectedResult.setAttribute('aria-selected', 'false');
      if (resultToSelect.scrollIntoView) resultToSelect.scrollIntoView({ block: 'nearest' });

      this.setLiveRegionText(resultToSelect.textContent.replace(/\s+/g, ' ').trim());
      this.input.setAttribute('aria-activedescendant', resultToSelect.id || '');
    };

    proto.ppPositionPanel = function () {
      var panel = this.querySelector('.predictive-search.pp-ps');
      if (!panel) return;
      panel.style.removeProperty('--pp-ps-shift');
      if (window.innerWidth < 1024 || !this.closest('.header')) return;

      var viewport = document.documentElement.clientWidth;
      var rect = panel.getBoundingClientRect();
      var shift = 0;
      if (rect.right > viewport - 16) shift = viewport - 16 - rect.right;
      if (rect.left + shift < 16) shift = 16 - rect.left;
      if (shift) panel.style.setProperty('--pp-ps-shift', Math.round(shift) + 'px');
    };

    var originalOpen = proto.open;
    proto.open = function () {
      originalOpen.apply(this, arguments);
      try {
        this.ppPositionPanel();
      } catch (e) {
        /* positioning is cosmetic only */
      }
    };
  });
})();
